import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { MessageCircle, Phone } from 'lucide-react';

const NAV_ITEMS = [
  { label: 'Home', type: 'home' },
  { label: 'Gallery', type: 'route', to: '/gallery' },
  { label: 'Amenities', type: 'anchor', id: 'specifications' },
  { label: 'Rates', type: 'anchor', id: 'rates' },
  { label: 'Contact', type: 'anchor', id: 'contact' },
];

const Mark = () => (
  <svg width="30" height="30" viewBox="0 0 30 30" fill="none" aria-hidden="true">
    <rect x="3" y="9" width="17" height="14" stroke="currentColor" strokeWidth="1.4" />
    <rect x="10" y="3" width="17" height="14" stroke="#c1531f" strokeWidth="1.4" />
  </svg>
);

const Nav = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const goTo = (item) => {
    setOpen(false);
    if (item.type === 'route') {
      navigate(item.to);
      return;
    }
    if (item.type === 'home') {
      if (location.pathname !== '/') {
        navigate('/');
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      return;
    }
    if (item.type === 'anchor') {
      if (location.pathname !== '/') {
        navigate('/', { state: { scrollTo: item.id } });
      } else {
        const el = document.getElementById(item.id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const isActive = (item) => {
    if (item.type === 'route') return location.pathname === item.to;
    if (item.type === 'home') return location.pathname === '/';
    return false;
  };

  return (
    <>
      <nav className="nav">
        <div className="nav-inner">
          <a className="nav-mark" onClick={() => goTo({ type: 'home' })}>
            <Mark />
            <span className="nav-wordmark">
              LEOLAND
              <span>by VengaFarms</span>
            </span>
          </a>

          <div className="nav-links">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.label}
                className={`nav-link ${isActive(item) ? 'active' : ''}`}
                onClick={() => goTo(item)}
              >
                {item.label}
              </a>
            ))}
            <a className="nav-cta" onClick={() => goTo({ type: 'anchor', id: 'availability' })}>
              Book Now
            </a>
          </div>

          <button
            className={`nav-burger ${open ? 'open' : ''}`}
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>

      <div className={`mobile-menu ${open ? 'open' : ''}`}>
        <div className="mobile-menu-links">
          {NAV_ITEMS.map((item) => (
            <a key={item.label} onClick={() => goTo(item)}>{item.label}</a>
          ))}
          <a onClick={() => goTo({ type: 'anchor', id: 'availability' })}>Book Now</a>
        </div>
        <div className="mobile-menu-foot">
          <a
            href="https://wa.me/918008002388"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-line-dark btn-block"
          >
            <MessageCircle size={16} /> WhatsApp Us
          </a>
          <a href="tel:+918008002388" className="btn btn-accent btn-block">
            <Phone size={16} /> +91 80080 02388
          </a>
        </div>
      </div>
    </>
  );
};

export default Nav;
